import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BaseSiteService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ResetPayload {
  newPassword: string;
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  baseSite$: Observable<string> = this.baseService.getActive();
  baseSiteId: any;
  occUrl = this.meta.getTag('name=occ-backend-base-url');

  constructor(private meta: Meta, protected http: HttpClient, protected baseService: BaseSiteService) {
    this.baseSite$.pipe(take(1)).subscribe((data) => {
      this.baseSiteId = data;
    });
  }

  postChangePassword(payload: ResetPayload) {
    const body = {
      newPassword: payload.newPassword,
      token: payload.token,
    };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post(`${this.occUrl.content}${environment.prefix}${this.baseSiteId}/resetpassword`, JSON.stringify(body), {
        headers,
      })
      .pipe(map((data) => data));
  }

  validateToken(payload: ResetPayload) {
    const body = {
      token: payload.token,
    };
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post(`${this.occUrl.content}${environment.prefix}${this.baseSiteId}/validateToken`, JSON.stringify(body), {
        headers,
      })
      .pipe(map((data) => data));
  }
}
